import { createContext, useContext } from 'react';

import type { FormInstance } from 'antd';

import type { CustomCommunityContractTypeFilterFormValues } from './types';

type CustomCommunityContractTypeFilterContextValue = {
  form: FormInstance<CustomCommunityContractTypeFilterFormValues>;
  reset: () => void;
};

export const CustomCommunityContractTypeFilterContext = createContext<CustomCommunityContractTypeFilterContextValue>({
  form: {} as FormInstance<CustomCommunityContractTypeFilterFormValues>,
  reset: () => {
    // Do nothing
  },
});

export const useCustomCommunityContractTypeFilterContext = () =>
  useContext(CustomCommunityContractTypeFilterContext);
